import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  image?: string;
}
const TestimonialCard = ({
  quote,
  author,
  image
}: TestimonialProps) => <motion.div whileHover={{
  y: -5
}} className="bg-navy rounded-xl border border-white/10 shadow-sm overflow-hidden flex flex-col" data-id="element-267">
    {image && <img src={image} alt={`Photo from ${author}`} loading="lazy" className="w-full h-64 object-cover" data-id="element-268" />}
    <div className="p-8 flex flex-col flex-grow" data-id="element-269">
      <div className="flex mb-4" data-id="element-270">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-271" />)}
      </div>
      <p className="text-ink italic mb-6 text-base md:text-lg leading-relaxed flex-grow" data-id="element-272">
        "{quote}"
      </p>
      <div data-id="element-273">
        <p className="font-heading font-bold text-white" data-id="element-274">{author}</p>
      </div>
    </div>
  </motion.div>;
export function Testimonials() {
  const testimonials = [{
    quote: "I was scared my son was falling behind because he couldn't sit still for more than 3 minutes. After just 14 days, he went from 3 minutes of focus to completing full 20-minute sessions completely on his own — and asking for more.",
    author: 'Jessica M. | 📍 Texas | Mom of a 7-year-old',
    image: 'https://cdn.magicpatterns.com/uploads/dkn2S3EX2fF5bwnU2NWtXP/ChatGPT_Image_29_jun_2026,_02_10_18_p.m..png'
  }, {
    quote: 'The Focus Warriors volume changed everything for my daughter. She used to cry and quit the moment something felt hard. After just 2 weeks, she now pushes through every challenge and finishes every single activity. That shift in her confidence is something no app could ever give her.',
    author: 'Amanda K. | 📍 Florida | Mom of an 8-year-old',
    image: 'https://cdn.magicpatterns.com/uploads/qWShBjuSxQRoD6i1B4nuMz/ChatGPT_Image_29_jun_2026,_02_14_21_p.m..png'
  }, {
    quote: 'I printed the 30-Day Planner and put it on the fridge. By day three my kids were reminding ME to print the activity. In 6 years of parenting I have never experienced anything like that with any product I have ever bought for them.',
    author: 'Rachel T. | 📍 California | Mom of two ages 6 and 9',
    image: 'https://cdn.magicpatterns.com/uploads/5MBhAa2XvPRBa9j7oKd2UU/ChatGPT_Image_29_jun_2026,_02_19_28_p.m..png'
  }, {
    quote: 'I never thought a $19 product would transform my evenings. We went from 45 minutes of iPad battles every night to 10 minutes of calm focused activity. No more guilt. No more arguments. Easily the best purchase I made this entire year.',
    author: 'Michelle P. | 📍 New York | Mom of a 9-year-old',
    image: 'https://cdn.magicpatterns.com/uploads/xdZSmExvz7RV8WGTzKTKke/ChatGPT_Image_29_jun_2026,_02_21_58_p.m..png'
  }, {
    quote: 'My son has ADHD. I have spent hundreds on apps, therapies, and kits. Nothing held his attention longer than 2 days. This is the first thing he asks for every single morning. We are on day 19 and counting.',
    author: 'Sarah L. | 📍 Ohio | Mom of a 6-year-old with ADHD'
  }, {
    quote: 'My kids are far more focused now. Everything is organized by age — I always know exactly which volume to use next.',
    author: 'Tom K. | 📍 Toronto | Dad of three kids'
  }];
  return <section className="bg-lightgray py-16 px-4 border-y border-border" data-id="element-275">
      <div className="max-w-6xl mx-auto" data-id="element-276">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-center text-white mb-12" data-id="element-277">
          WHAT PARENTS WHO ALREADY HAVE KIT THE FOCUSED MINDSET™ SAY:
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-278">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-279" />)}
        </div>
      </div>
    </section>;
}